// eslint-disable-next-line no-unused-vars
import { LayoutProps } from 'prensa'

export const SUBJECT_DEFAULT: LayoutProps['subject'] = {
  bg_color: 'white',
  color: 'primary1',
  enabled: true,
  font_size: ['14px', '14px'],
  line_height: ['16px', '16px'],
  variant: 'default'
}
export const SUBJECT_FILLED: LayoutProps['subject'] = {
  bg_color: 'primary1',
  color: 'white',
  enabled: true,
  font_size: ['16px', '16px'],
  line_height: ['18px', '18px'],
  variant: 'filled'
}